import React from "react";


const SectionImage = ({src}) => {


    return(
        <>
            <div className="d-flex">
                <div className="bitmap-container">
                    <img src={src} alt="" className="bitmap img-fluid" />
                </div>
            </div>
        </>
    )
}

export default SectionImage